module.exports = __webpack_public_path__ + "img/EDQ16_Z.c69b69b1.png";